import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function createSuccess(draft: Draft<IProductData>) {
  draft.create.config.isLoading = false;
}

export default createSuccess;
